import React from "react";
import SportEventCalendarApp from "../sports_calendar";
import { Helmet } from "react-helmet";
import "../sports_calendar/styles.css";

/**
 * Render react app with redux store
 */
interface IProps {
  selectedCountry: string;
  isDesktopResolution: boolean;
}

const SportsCalender: React.FC<IProps> = ({ selectedCountry }) => {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sports Calendar</title>
      </Helmet>
      <SportEventCalendarApp selectedCountry={selectedCountry} />
    </React.Fragment>
  );
};

export default SportsCalender;
